<template>
    <div class="parent contenedor-slim">
      <div class="div1">
        <img src="../assets/slim-soft/Logo_1.png" alt="Imagen de prueba" class="logoslim" />
      </div>
      <div class="div2">
        <img src="../assets/slim-soft/Texto.png" alt="Imagen adicional debajo" class="tituloslim"/>
      </div>
      <div class="div2b">
        <img src="../assets/slim-soft/Texto 2_3.png" alt="Nueva imagen debajo de Texto.png" class="descripcionslim"/>
      </div>
      <div class="div3">
        <img class="cepilloslim" src="../assets/slim-soft/cepilloSlim.png" alt="Imagen centrada" />
      </div>
      <div class="div4">
        <img class="cerdasslim" src="../assets/slim-soft/cerdas_1.png" alt="Imagen lateral derecha" />
      </div>
      <div class="div5">
        <img src="../assets/slim-soft/Texto 3_1.png" alt="Imagen adicional debajo de cerdas" class="texto3slim"/>
        <div class="boton" @click="mostrarModal = true">
          <!-- Este es el botón con imagen de fondo -->
        </div>
      </div>
      <div class="div6">
        *vs un cepillo dental control después de 7 días de uso.
      </div>
      <div class="div6b">
        **Cerdas cónicas y más densas, 17 veces más delgadas que una cerda <br> normal (0.01mm), en un solo nivel.
      </div>
      <div class="footer-text">
        Rosing CK, Cavagni J, Gaio EJ, Muniz FW, Oballe HJ, Ranzan N, Friedrich SA, Severo RM, Gittins E, Stewart B, Zhang YP. Efficacy of two soft-bristle toothbrushes in plaque removal: a <br> randomized controlled trial. Braz Oral Res. 2016 Nov 10;30(1):e134.
      </div>
  
      <!-- Modal fuera del div.parent para no alterar la estructura -->
  <div v-if="mostrarModal" class="modal">
    <div class="modal-content">
      <img src="../assets/slim-soft/Documento.png" alt="Contenido del Modal">
      <button class="close-btn" @click="mostrarModal = false">X</button>
    </div>
  </div>
  
    </div>
  </template>
  
<!--<script>
  import { ref, onMounted } from "vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "ResponsiveGrid",
  setup() {
    const mostrarModal = ref(false);
    onMounted(() => {
      const elements = [
        { selector: ".logoslim", x: -300, y: -600, rotation: -20, scale: 0.5 },
        { selector: ".tituloslim", x: -250, y: -400, rotation: -10, scale: 0.8 },
        { selector: ".descripcionslim", x: -200, y: 450, rotation: 8, scale: 0.9 },
        { selector: ".texto3slim", x: 450, y: 500, rotation: -5, scale: 0.7 },
      ];

      elements.forEach((item, index) => {
        gsap.from(item.selector, {
          x: item.x,
          y: item.y,
          rotation: item.rotation,
          scale: item.scale,
          opacity: 0,
          duration: 18 + index * 1.5, // Más lento (entre 16 y 22 segundos)
          ease: "power4.out",
          stagger: 1, // Aumentamos la diferencia entre elementos
          scrollTrigger: {
            trigger: ".contenedor-slim",
            start: "top 95%", //95% Se activa casi al final para máxima suavidad
            end: "top top",
            scrub: 5, // Aún más control con el scroll
          },
        });
      });

      // 🔥 Animación HIPER LENTA para .cepilloslim (22s)
      gsap.from(".cepilloslim", {
        x: -50,       // Leve desplazamiento lateral
        y: -1800,     // Mucho más arriba, flotando lentamente
        rotation: 30, // Comienza con una inclinación más marcada
        scale: 1.6,   // Apenas más grande al inicio
        opacity: 0,   // Inicia invisible
        duration: 22, // Movimiento ULTRA LENTO
        ease: "power1.out", // Caída flotante más natural
        scrollTrigger: {
          trigger: ".contenedor-slim",
          start: "top 210%", //125
          end: "top 1%",
          scrub: 5, // Control de desplazamiento ultra fluido
        },
      });

      // 🔥 Animación HIPER LENTA para .cerdasslim (20s)
      gsap.from(".cerdasslim", {
        x: 250,       // Se mueve desde la derecha
        y: -1600,     // Aparece desde más arriba
        rotation: -20, // Ligeramente girado al inicio
        scale: 1.5,   // Más grande al inicio
        opacity: 0,   // Comienza invisible
        duration: 20, // Súper lento para apreciarse mejor
        ease: "power1.out", // Suavidad realista en la caída
        scrollTrigger: {
          trigger: ".contenedor-slim",
          start: "top 99%",
          end: "top 1%",
          scrub: 5, // Control de desplazamiento ultra suave
        },
      });
    });
    return { mostrarModal };
  },
};
</script> -->
  
<script>
import { ref, onMounted } from "vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
name: "ResponsiveGrid",
setup() {
  const mostrarModal = ref(false);
  onMounted(() => {
  const elements = [
    { selector: ".logoslim", x: -300, y: -600, rotation: -20, scale: 0.5 },
    { selector: ".tituloslim", x: -250, y: -400, rotation: -10, scale: 0.8 },
    { selector: ".descripcionslim", x: -200, y: 450, rotation: 8, scale: 0.9 },
    { selector: ".texto3slim", x: 450, y: 500, rotation: -5, scale: 0.7 },
  ];

  const contenedor = document.querySelector(".contenedor-slim");
  let played = false;

  contenedor.addEventListener("mouseenter", () => {
    if (played) return; // evitar repetir la animación
    played = true;

    elements.forEach((item, index) => {
      gsap.from(item.selector, {
        x: item.x,
        y: item.y,
        rotation: item.rotation,
        scale: item.scale,
        opacity: 0,
        duration: 2.5 + index * 0.5,
        ease: "power4.out",
        stagger: 0.2,
      });
    });

    gsap.from(".cepilloslim", {
      x: -50,
      y: -1800,
      rotation: 30,
      scale: 1.6,
      opacity: 0,
      duration: 4.5,
      ease: "power1.out",
    });

    gsap.from(".cerdasslim", {
      x: 250,
      y: -1600,
      rotation: -20,
      scale: 1.5,
      opacity: 0,
      duration: 4,
      ease: "power1.out",
    });
  });
});

  return { mostrarModal };
},
};
</script>

  <style scoped>
  .parent {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(12, 1fr);
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background: url('../assets/slim-soft/Fondo_1.png') no-repeat center center;
    background-size: cover;
    position: relative;
  }
  
  /* Contenedor 1 */
  .div1 {
    grid-area: 1 / 1 / 2 / 4;
    min-height: auto;
    box-sizing: border-box;
    transform: translate(15%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
  }
  
  .div1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  /* Contenedor 2 */
  .div2 {
    grid-area: 2 / 1 / 3 / 4;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(180px, 70px);
  }
  
  .div2 img {
    width: 150%;
    max-width: 500px;
    height: auto;
    object-fit: contain;
  }
  
  /* Nuevo Contenedor 2b */
  .div2b {
    grid-area: 3 / 1 / 4 / 4;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(136px, 110px);
  }
  
  .div2b img {
    width: 120%;
    max-width: 450px;
    height: auto;
    object-fit: contain;
  }
  
  
  /* Contenedor 3 */
  .div3 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: auto;
    pointer-events: none;
  }
  
  .div3 img {
    width: 560px;
    height: auto;
    object-fit: contain;
  }
  
  /* Contenedor 4 (cerdas centrada verticalmente) */
  .div4 {
    position: absolute;
    top: 50%;
    right: 90px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
  }
  
  .div4 img {
    width: 350px;
    height: auto;
    object-fit: contain;
  }
  
  /* Contenedor 5 (Texto 2_3 y botón) */
  .div5 {
    position: absolute;
    top: calc(46% + 200px);
    right: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    height: auto;
  }
  
  .div5 img {
    width: 350px;
    height: auto;
    object-fit: contain;
  }
  
  /* Botón dentro de div5 */
  .boton {
    width: 200px;
    height: 60px;
    background: url('../assets/slim-soft/Botón documento.png') no-repeat center center;
    background-size: contain;
    margin-top: 15px;
    cursor: pointer;
    pointer-events: all;
  }
  
  /* Modal */
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8); /* Fondo oscuro */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .modal-content {
    position: relative;
    width: 90%;
    max-width: 600px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-content img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  
  /* Botón de cerrar */
  .close-btn {
    position: absolute;
    top: 0px;
    right: 0px;
    background: white;
    border: none;
    width: 50px;
    height: 50px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 13%;
  }
  
  .close-btn:hover {
    background: red;
    color: white;
  }
  
  
  /* Texto debajo de la imagen central */
  .div6 {
    position: absolute;
    top: calc(56% + 320px);
    left: 50%;
    transform: translateX(-50%);
    font-size: 23px;
    font-family: 'ColgateReady-Light';
    font-weight: 100;
    color: #847D86;
    text-align: center;
    white-space: nowrap;
  }
  
  /* Nuevo texto centrado debajo de div6 */
  .div6b {
    position: absolute;
    top: calc(56% + 360px);
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    font-family: 'ColgateReady-Light';
    font-weight: 100;
    color: #847D86;
    text-align: center;
    white-space: nowrap;
    line-height: 23px;
  }
  
  /* Texto pequeño en la parte inferior */
  .footer-text {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 10px;
    color: #555;
    text-align: center;
    font-family: 'ColgateReady-Regular';
    font-style: italic;
    white-space: nowrap;
    margin-bottom: 3px; /* Un pequeño margen desde el borde */
  }
  
  @media (max-width: 1024px) and (max-width: 1160px) {
    .parent {
      height: 150vh;
    }
  }
  </style>
  